import { useStore } from "@nanostores/react";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { useSidebarWidth } from "./hooks/useSidebarWidth";
import { $subNavigationNode } from "./SubNavigation.store";

type Props = {
  isCollapsed: boolean;
  horizontal?: boolean;
  showOnlySubNav?: boolean;
};

export const SubNavigation = ({
  isCollapsed,
  horizontal = false,
  showOnlySubNav = false,
}: Props) => {
  const node = useStore($subNavigationNode);
  const { sidebarWidth } = useSidebarWidth(isCollapsed, showOnlySubNav);

  if (!node) return null;

  if (horizontal) {
    return (
      <div className="hidden md:block sticky top-0 border-b-1 border-sidebar/border bg-background/sidebar/primary z-navbar md:-mx-4 lg:-mx-8 2xl:-mx-14">
        {node}
      </div>
    );
  }

  return (
    <div className="flex h-full">
      <div className={`${sidebarWidth} defaultTransition`} />
      <div
        className={cnTwMerge(
          "max-w-60 min-w-60 h-full min-h-0 p-3 border-r-1 border-t-sidebar/border border-r-sidebar/border left-auto flex-1 flex-col relative",
          showOnlySubNav && "!w-full",
        )}
      >
        <div className="sticky top-24"> {node}</div>
      </div>
    </div>
  );
};
